import React from 'react';
import {isInjectedRuHost} from 'app/utils/injectedRuHost';

const LICENSE_IMAGE_URL = 'https://seal.cgcb.info/1c0246df-1aa7-485a-a24c-21ae5e730000';
// eslint-disable-next-line max-len
const LICENSE_CLICK_URL = 'https://cert.gcb.cw/certificate?id=ZXlKcGRpSTZJbXB3ZUhScU5TOWpiRWxWVkZSQk1uUnJhM2hoWVdjOVBTSXNJblpoYkhWbElqb2ljVUpxVWxsVVJFeElXVGxVT0VkemJVMVRlVk5sUVQwOUlpd2liV0ZqSWpvaU9URm1aVE0wWXpZMlptTmlPVFZoWlRCak5qazFZakEzTm1abFpURmtZV1JoWmprMVpUZzVZamsyTm1RNU5UZGpZakZqWW1OaE5tVmlPVEU0WVRjd01TSXNJblJoWnlJNklpSjk=';
// eslint-disable-next-line max-len
const LICENSE_CLICK_URL_TO_MIRROR = 'https://cert.gcb.cw/certificate?id=ZXlKcGRpSTZJakUwZHpsaE5HUkNWaXRrYVhrM1IwWlhkSEJtVmtFOVBTSXNJblpoYkhWbElqb2laVXRSYTA5MGNucFhOaXRwUlZoNGFrOVBjR2xEUVQwOUlpd2liV0ZqSWpvaU5ERmxaalF5WVdVNFl6STRZVGxtTURFMk1UYzFNbUV6WW1Rek5XUXpOamM1TmpkbFpUbG1aRGszTkRrek5XRTVNelJtTmpjeE9EWTBaRE15T0RFMFppSXNJblJoWnlJNklpSjk=';
const MIRROR_LICENSE = isInjectedRuHost();

const License: React.FC = () => {
    const click_url = MIRROR_LICENSE ? LICENSE_CLICK_URL_TO_MIRROR : LICENSE_CLICK_URL;

    return (
        <div id="license">
            <div id="apg-seal-container" className="apg-license">
                <div>
                    <a target="_blank" rel="noreferrer" href={click_url}>
                        <img
                            style={{maxHeight: '100%', maxWidth: '100%'}}
                            src={LICENSE_IMAGE_URL}
                        />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default License;
